import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Header from "../Components/common/Header";
import Sidebar from "../Components/common/sidebar";
import FrozenSidebar from "../Components/common/FrozenSidebar";
import { useDispatch } from 'react-redux';
import { loadSellerMeIfNeeded } from '../Actions/bootstrapSellerMe';
import { ensureVendorFrozenCheck } from '../Actions/bootstrapVendorFrozenCheck';

const FrozenRoute = ({ component: Component, ...restOfProps }) => {
  const dispatch = useDispatch();
  
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [shouldRedirectToHome, setShouldRedirectToHome] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const checkAccess = async () => {
      try {
        
        // Check authentication first
        const token = localStorage.getItem("token");
        if (!token) {
          if (isMounted) {
            setIsAuthenticated(false);
            setIsLoading(false);
          }
          return;
        }

        if (isMounted) {
          setIsAuthenticated(true);
        }

        try {
          await loadSellerMeIfNeeded(dispatch);
        } catch (e) {
          console.log(e);
        }

        
        // Check vendor status
        const response = await ensureVendorFrozenCheck(dispatch);

        // Only update state if component is still mounted
        if (!isMounted) {
          return;
        }
        
        // Handle different response types
        if (response.message === "seller fetched") {
          // Active vendor shouldn't be on frozen page
          setShouldRedirectToHome(true);
        } else if (response.message === "seller temporarily inactive") {
          // Vendor should be on frozen page
          
          // Store freeze details for the component
          if (response.data) {
            const freezeData = {
              tmpStatus: response.data.tmpStatus,
              daysSinceLastOrder: response.data.daysSinceLastOrder,
              hasPendingRequest: response.data.hasPendingRequest,
              pendingRequest: response.data.pendingRequest
            };
            localStorage.setItem('freezeDetails', JSON.stringify(freezeData));
          }
          
          setShouldRedirectToHome(false);
        } else if (response.message === "Seller Not Found") {
          setShouldRedirectToHome(true);
        } else if (response.message === "Seller Not Activated") {
          setShouldRedirectToHome(true);
        } else {
          setShouldRedirectToHome(true);
        }
        
        setError(null);
        setIsLoading(false);
        
      } catch (error) {
        
        // Only update state if component is still mounted
        if (isMounted) {
          // On error, check localStorage for fallback
          const freezeDetails = localStorage.getItem("freezeDetails");
          if (freezeDetails) {
            try {
              const parsed = JSON.parse(freezeDetails);
              if (parsed.tmpStatus === true) {
                setShouldRedirectToHome(false);
              } else {
                setShouldRedirectToHome(true);
              }
            } catch (parseError) {
              setShouldRedirectToHome(true);
            }
          } else {
            setShouldRedirectToHome(true);
          }
          
          setError(error);
          setIsLoading(false);
        }
      }
    };

    checkAccess();
    
    // Cleanup function to prevent memory leaks
    return () => {
      isMounted = false;
    };
  }, []);


  // Loading state
  if (isLoading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100vh', backgroundColor: '#f8f9fa' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <h5 className="mb-2">Checking Account Status</h5>
          <p className="text-muted">Please wait while we verify your account...</p>
          
          {error && (
            <div className="alert alert-warning mt-3" style={{ maxWidth: '400px' }}>
              <small>
                <strong>Notice:</strong> Using cached account status due to connection issue.
              </small>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Redirect to="/" />;
  }

  // Redirect to home if vendor is active
  if (shouldRedirectToHome) {
    return <Redirect to="/home" />;
  }

  
  return (
    <Route
      {...restOfProps}
      render={(props) => {
        return (
          <>
            <div className="row align-items-start">
              <FrozenSidebar />
              <div
                className="rightbar"
                style={{ 
                  padding: '0px 7px', 
                  marginLeft: "250px", 
                  width: "calc(100vw - 227px)",
                  backgroundColor: "#ecedef"
                }}
              >
                {/* <Header /> */}
                <div style={{ minHeight: "500px" }}>
                  <div style={{ minHeight: "500px", backgroundColor: "#fff" }}>
                    <Component {...props} />
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      }}
    />
  );
};

export default FrozenRoute;